import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from './layout';
import { client as CLIENTS_URL, invoiceedit as EDIT_INVOICE, invoiceupdate as UPDATE_INVOICE_URL } from './proxyurls';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import Select from 'react-select';

function EditInvoice() {
    const [clients, setClients] = useState([]);
    const [amountRows, setAmountRows] = useState([
        { reference_id: '', usd: '', recieved_payment: '', inr: '' }
    ]);
        const handleAmountRowChange = (index, e) => {
        const { name, value } = e.target;
        setAmountRows(prevRows => {
            const updatedRows = [...prevRows];
            updatedRows[index][name] = value;
            return updatedRows;
        });
    };
       const handleAddRow = () => {
        setAmountRows(prevRows => [
            ...prevRows,
            { reference_id: '', usd: '', recieved_payment: '', inr: '' }
        ]);
    };
    const handleRemoveRow = (index) => {
        setAmountRows(prevRows => prevRows.filter((_, i) => i !== index));
    };
    const [formData, setFormData] = useState({
        client_id: '',
        project_month: '',
        recieved_payment: '',
        service_detail: '',
        title: '',
        reference_id: '',
        usd: '',
        status: '',
        invoice_id: '',
        payment_status: '',
        assigned_to: '',
        assigned_contact: '',
        assigned_email: [],
        inr: '',
        payment_remarks: '',
        // project_id: ''
    });
    const [emailOptions, setEmailOptions] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { invoiceId } = useParams();

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await axios.get(CLIENTS_URL);
                const clientOptions = response.data.map(client => ({
                    value: client.id,
                    label: `${client.firstname} (${client.email}${client.email1 ? `, ${client.email1}` : ''})`,
                    phone: client.phone,
                    email: client.email,
                    email1: client.email1
                }));
                setClients(clientOptions);
            } catch (error) {
                console.error('Clients Not Found:', error);
                setErrorMessage('Clients Not Found');
            }
        };

        fetchClients();
    }, []);

    useEffect(() => {
        if (invoiceId) {
            const fetchInvoice = async () => {
                try {
                    const response = await axios.get(EDIT_INVOICE(invoiceId));
                    const data = response.data;

                    setFormData(prevData => ({
                        ...prevData,
                        ...data,
                        assigned_email: Array.isArray(data.assigned_email) ? data.assigned_email : [] // Ensure it's an array
                    }));
                    setAmountRows(Array.isArray(data.invoiceReference) && data.invoiceReference.length > 0
                        ? data.invoiceReference
                        : [{
                            reference_id: data.reference_id || '',
                            usd: data.usd || '',
                            recieved_payment: data.recieved_payment || '',
                            inr: data.inr || ''
                        }]
                    );
                    const assignedClient = clients.find(client => client.value === data.assigned_to);
                    if (assignedClient) {
                        const { email, email1 } = assignedClient;
                        setEmailOptions(email1 ? [email, email1] : [email]);
                    }
                } catch (error) {
                    console.error('Invoice Not Found', error);
                    setErrorMessage('Invoice Not Found');
                }
            };

            fetchInvoice();
        }
    }, [invoiceId, clients]);

    const handleAssignedToChange = (selectedOption) => {
        const selectedPerson = selectedOption || {};
        setFormData(prevData => ({
            ...prevData,
            assigned_to: selectedPerson.value || '',
            assigned_contact: selectedPerson.phone || '',
            assigned_email: []
        }));

        const assignedPersonClient = clients.find(client => client.value === selectedPerson.value);
        if (assignedPersonClient) {
            const { email, email1 } = assignedPersonClient;
            setEmailOptions(email1 ? [email, email1] : [email]);
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleDateChange = (date) => {
        setFormData(prevData => ({
            ...prevData,
            project_month: date ? date.toISOString().split('T')[0] : ''
        }));
    };

    const handleEmailChange = (selectedOptions) => {
        const selectedEmails = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setFormData(prevData => ({
            ...prevData,
            assigned_email: selectedEmails
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const inrValue = (formData.inr || '').toString().trim();
        const recieved_paymentValue = (formData.recieved_payment || '').toString().trim();
        const dataToSend = {
            ...formData,
            inr: inrValue === '' ? '0' : inrValue,
            recieved_payment: recieved_paymentValue === '' ? '0' : recieved_paymentValue,

            project_month: formData.project_month
                ? formData.project_month
                : new Date().toISOString().split('T')[0],
        };

        try {
            const response = await axios.put(UPDATE_INVOICE_URL(invoiceId), dataToSend, {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true
            });
            const { data } = response;

            if (response.status === 200) {
                setSuccessMessage('Invoice updated successfully');
                setErrorMessage('');
                setTimeout(() => {
                    // navigate(`/view-invoice/${data.updatedInvoice.id}`);
                    navigate("/invoice");
                    setSuccessMessage('');
                }, 1000);
            } else {
                setErrorMessage(data.error || 'Error updating invoice.');
            }
        } catch (error) {
            console.error('Error updating invoice:', error);
            setErrorMessage('Error updating invoice.');
        }
    };

    const handleCancel = () => {
        navigate('/invoice');
    };

    return (
        <Layout>
            <div style={{ padding: '39px' }}>
                {successMessage && <div className="alert alert-success">{successMessage}</div>}
                {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                <h3 className='py-3 px-3'>Edit Invoice</h3>
                <form onSubmit={handleSubmit} className='py-3 px-3'>
                    <div className="row mb-4">
                        <div className="col-3">
                            <label htmlFor="assigned_to" className="form-label">Attorney</label>
                            <Select
                                id="assigned_to"
                                options={clients}
                                value={clients.find(client => client.value === formData.assigned_to) || null}
                                onChange={handleAssignedToChange}
                                placeholder="Search and select a person"
                                isClearable
                                isSearchable
                            />
                        </div>
                        <div className="col-3">
                            <label htmlFor="assigned_email" className="form-label">Attorney Emails</label>
                            <Select
                                id="assigned_email"
                                options={emailOptions.map(email => ({ value: email, label: email }))}
                                value={formData.assigned_email.map(email => ({ value: email, label: email }))}
                                onChange={handleEmailChange}
                                placeholder="Select emails"
                                isMulti
                                isClearable
                                required
                            />
                        </div>
                        <div className="col-3 d-grid">
                            <label htmlFor="project_month" className="form-label">Project Date</label>
                            <DatePicker
                                selected={formData.project_month ? new Date(formData.project_month) : new Date()}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM-dd"
                                className="form-control"
                                id="project_month"
                                placeholderText="Select Date"
                            />
                        </div>
                        <div className="col-3">
                            <label htmlFor="invoice_id" className="form-label">Invoice ID</label>
                            <input
                                type="text"
                                id="invoice_id"
                                className="form-control"
                                name="invoice_id"
                                value={formData.invoice_id}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-6">
                            <label htmlFor="title" className="form-label">Title</label>
                            <textarea
                                id="title"
                                className="form-control"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-6">
                            <label htmlFor="service_detail" className="form-label">Service Details</label>
                            <textarea
                                id="service_detail"
                                className="form-control"
                                name="service_detail"
                                value={formData.service_detail}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    {/* <div className="row mb-4">
                        <div className="col-12">
                            <label htmlFor="title" className="form-label">Title</label>
                            <input
                                type="text"
                                id="title"
                                className="form-control"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div> */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <label className="form-label">Amounts</label>
                            {amountRows.map((row, idx) => (
                                <div className="row mb-2" key={idx}>
                                    <div className="col-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="reference_id"
                                            placeholder="Reference ID"
                                            value={row.reference_id}
                                            onChange={e => handleAmountRowChange(idx, e)}
                                            required
                                            disabled
                                        />
                                    </div>
                                    <div className="col-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="usd"
                                            placeholder="USD Amount"
                                            value={row.usd}
                                            onChange={e => handleAmountRowChange(idx, e)}
                                            required
                                            disabled
                                        />
                                    </div>
                                    <div className="col-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="recieved_payment"
                                            placeholder="Received Payment (USD)"
                                            value={row.recieved_payment}
                                            onChange={e => handleAmountRowChange(idx, e)}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="inr"
                                            placeholder="INR Amount"
                                            value={row.inr}
                                            onChange={e => handleAmountRowChange(idx, e)}
                                            disabled
                                        />
                                    </div>
                                    {/* <div className="col-1 d-flex align-items-center">
                                        {amountRows.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleRemoveRow(idx)}
                                            >
                                                -
                                            </button>
                                        )}
                                        {idx === amountRows.length - 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm ms-2"
                                                onClick={handleAddRow}
                                            >
                                                +
                                            </button>
                                        )}
                                    </div> */}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-3">
                            <label htmlFor="payment_status" className="form-label">Payment Status</label>
                            <select
                                id="payment_status"
                                className="form-control"
                                name="payment_status"
                                value={formData.payment_status}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Payment Status</option>
                                <option value="1">Paid</option>
                                <option value="0">Pending</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <button type="submit" className="btn btn-primary">Save</button>
                            <button type="button" className="btn btn-secondary ms-2" onClick={handleCancel}>Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    );
}

export default EditInvoice;
